import { SocialPlatform, YoutubePlatform } from '@app/modules/social-export/domain/platforms';
import { YoutubeFeatureManage } from '@app/modules/youtube/screens/manage/YoutubeFeatureManage';

interface Props {
  platform: SocialPlatform;
  stationId: string;
}

/**
 * Returns platform-specific manage UI shown below the connection alert when a station is connected.
 */
export function FeatureManageFactory({ platform, stationId }: Props) {
  if (platform === YoutubePlatform) {
    return <YoutubeFeatureManage stationId={stationId} />;
  }

  return null;
}
